var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDenyIco = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 160,
    viewBox: "0 0 134 160",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.0039L27.3416 17.2911C33.6305 16.4372 39.717 14.4785 45.3175 11.5064L67 0L89.5948 11.7299C95.0378 14.5556 100.928 16.4299 107.009 17.2709L134 21.0039V70.3773C134 96.0179 121.648 120.105 100.784 135.152L66.33 160L32.598 135.181C12.0955 120.096 0 96.2286 0 70.8567V21.0039Z",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8068 157.408L66.33 160L100.784 135.152C121.648 120.105 134 96.0179 134 70.3773V21.0039L129.98 20.4479V68.177C129.98 93.8361 117.611 117.938 96.721 132.983L62.8068 157.408Z",
    fillOpacity: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4675 52C50.4675 43.7157 57.8694 37 67 37C76.1306 37 83.5325 43.7157 83.5325 52V67H50.4675V52ZM89.0433 67V52C89.0433 40.9543 79.1742 32 67 32C54.8258 32 44.9567 40.9543 44.9567 52V67H38.5274C32.9476 67 28.4242 71.1041 28.4242 76.1667V102.833C28.4242 107.896 32.9476 112 38.5274 112H95.4726C101.052 112 105.576 107.896 105.576 102.833V76.1667C105.576 71.1041 101.052 67 95.4726 67H89.0433ZM67 82C63.9565 82 61.4892 84.2386 61.4892 87V92C61.4892 94.7614 63.9565 97 67 97C70.0435 97 72.5108 94.7614 72.5108 92V87C72.5108 84.2386 70.0435 82 67 82Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDenyIco);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deny-ico.54533dbe4501e401466964dcada71bf9.svg";